const projectName = 'prepress24.pl';

import { logged } from '@/services/user';

function guard (to, from, next) {
    if (logged()) {
        next()
    } else {
        next({ name: 'Login' })
    }
}

const routes = [
    {
        path: '/',
        redirect: '/pl/'
    },
    {
        path: '/:lang/',
        component: () => import('@/pages/views/Home'),
        name: 'Home',
        props: true,
        meta: {
            title: projectName,
        },
    },
    {
        path: '/:lang/login',
        component: () => import('@/pages/views/Login'),
        name: 'Login',
        props: true,
        meta: {
            title: `${projectName} - zaloguj się`,
        },
    },
    {
        path: '/:lang/register',
        component: () => import('@/pages/views/Register'),
        name: 'Register',
        props: true,
        meta: {
            title: `${projectName} - zarejestruj się`,
        },
    },
    {
        path: '/:lang/remember-password',
        component: () => import('@/pages/views/RememberPassword'),
        name: 'RememberPassword',
        props: true,
        meta: {
            title: `${projectName} - przypomnij hasło`,
        },
    },
    {
        path: '/:lang/remember-password/:token',
        component: () => import('@/pages/views/ResetPassword'),
        name: 'ResetPassword',
        props: true,
        meta: {
            title: `${projectName} - przypomnij hasło`,
        },
    },
    {
        path: '/:lang/panel/:slug',
        component: () => import('@/pages/views/ProfilPanel'),
        name: 'ProfilPanel',
        props: true,
        beforeEnter: guard,
        meta: {
            title: `${projectName} - Panel klienta`,
        },
    },
    {
        path: '/:lang/products',
        component: () => import('@/pages/views/Products'),
        name: 'Products',
        props: true,
        beforeEnter: guard,
        meta: {
            title: `${projectName} - Produkty`,
        },
    },
    {
        path: '/:lang/order/:productCode/:configCode/:itemId?',
        component: () => import('@/pages/views/order/Order'),
        name: 'Order',
        props: true,
        beforeEnter: guard,
        meta: {
            title: `${projectName} - Zamówienie`,
        },
    },
    {
        path: '/:lang/order-summary',
        component: () => import('@/pages/views/order/OrderSummary'),
        name: 'OrderSummary',
        props: true,
        beforeEnter: guard,
        meta: {
            title: `${projectName} - Podsumowanie Zamówienie`,
        },
    },
    {
        path: '/:lang/order-payment',
        component: () => import('@/pages/views/order/OrderPayment'),
        name: 'OrderPayment',
        props: true,
        beforeEnter: guard,
        meta: {
            title: `${projectName} - Wybór płatności`,
        },
    },
    {
        path: '/:lang/order-payment/:token/status',
        component: () => import('@/pages/views/order/OrderPaymentStatus'),
        name: 'OrderPaid',
        props: true,
        beforeEnter: guard,
        meta: {
            title: `${projectName} - Wybór płatności`,
        },
    },
    {
        path: '/:lang/order-completed/:token',
        component: () => import('@/pages/views/order/OrderCompleted'),
        name: 'OrderCompleted',
        props: true,
        beforeEnter: guard,
        meta: {
            title: `${projectName} - Wybór płatności`,
        },
    },
    {
        path: '/404',
        component: () => import('@/pages/views/PageNotFound')
    },
    {
        path: '*',
        redirect: '/404'
    },
];

export default routes;
